import { inject, Injectable } from '@angular/core';
import { app } from '@df/core/app';
import { ElementHeightService } from '@df/dom/element-height/element-height.service';
import { getAbsolutePosition } from '@df/dom/fn/get-absolute-position';
import defaults from 'lodash-es/defaults';
import { TimeoutService } from '../../../dragonfly-ng/src/timeout.service';
import { FocusTrapService } from '../accessibility/focus-trap.service';

export const DEFAULT_SCROLLTO_OPTIONS: IScrollToOptions = {
    offset: undefined,
    behavior: 'smooth'
};
export interface IScrollToOptions {
    offset?: number;
    offsetAdd?: number;
    behavior?: 'smooth' | 'auto';
}

@Injectable({
    providedIn: 'root'
})
export class ScrollToService {
    private timeoutService = inject(TimeoutService);
    private elementHeightService = inject(ElementHeightService);
    private focusTrapService = inject(FocusTrapService);

    scrollTo(target: Element | number | string, options: Partial<IScrollToOptions> = {}) {
        defaults(options, DEFAULT_SCROLLTO_OPTIONS);
        const root = app.client.getRootElement();
        if (typeof target !== 'number') {
            if (typeof target === 'string') {
                target = document.querySelector(target)!;
            }
            if (!target) {
                return;
            }
            if (target instanceof HTMLElement) {
                const el = target as HTMLElement;
                this.timeoutService.setTimeout(() => {
                    this.focusTrapService.focusNextElement(false, [el]);
                }, 1000);
            }
            if (!root.contains(target)) {
                target.scrollIntoView(options);
                return;
            }
            target = getAbsolutePosition(target as HTMLElement).y - getAbsolutePosition(root).y;
        }
        // with this logic offset is automatically calculated basing on element height directive
        this.timeoutService.setTimeout(() => {
            const offset =
                typeof options.offset === 'undefined'
                    ? this.elementHeightService.getTopOffset() + (options.offsetAdd || 20)
                    : options.offset;
            root.scrollTo({ top: target - offset, behavior: options.behavior });
        }, 200);
    }
}
